<template>
  <div
    class="image-wrap image-loader"
    ref="wrap"
    :class="{ error: error, noBg: noBg }"
  >
    <img
      :src="realSrc"
      ref="image"
      :style="{
        height: `${height}px`,
        width: `${width}px`,
        'margin-top': `${marginTop}px`,
        'margin-left': `${marginLeft}px`
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'image-loader',
  props: {
    src: {
      type: String,
      default: ''
    },
    noBg: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      error: false,
      width: 0,
      height: 0,
      marginTop: 0,
      marginLeft: 0,
      realSrc: ''
    }
  },
  watch: {
    src () {
      this.load()
    }
  },
  methods: {
    load () {
      let _this = {
        height: this.$refs.wrap ? this.$refs.wrap.getBoundingClientRect().height : 0,
        width: this.$refs.wrap ? this.$refs.wrap.getBoundingClientRect().width : 0
      }
      let _image = new Image()
      _image.onload = () => {
        if (_image.width > 0 && _image.height > 0) {
          if (_image.width / _image.height >= _this.width / _this.height) {
            if (_image.width > _this.width) {
              this.width = _this.width
              this.height = (_image.height * _this.width) / _image.width
            } else {
              this.width = _image.width
              this.height = _image.height
            }
          } else {
            if (_image.height > _this.height) {
              this.height = _this.height
              this.width = (_image.width * _this.height) / _image.height
            } else {
              this.width = _image.width
              this.height = _image.height
            }
          }
          if (this.height < _this.height) {
            this.marginTop = (_this.height - this.height) / 2
          } else {
            this.marginTop = 0
          }
          if (this.width < _this.width) {
            this.marginLeft = (_this.width - this.width) / 2
          } else {
            this.marginLeft = 0
          }
          this.error = false
          this.realSrc = this.src
        } else {
          this.error = true
          this.realSrc = ''
        }
        this.loading = false
      }
      _image.onerror = () => {
        this.loading = false
        this.error = true
        this.realSrc = ''
      }
      _image.src = this.src
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.image-loader.image-wrap {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/bg_logo.png");
  overflow: hidden;
  &.noBg {
    background-color: transparent;
  }
  img {
    display: block;
  }
  &.error {
    background-position: center;
    background-repeat: no-repeat;
    img {
      display: none;
    }
  }
}
</style>
